module.exports = __webpack_public_path__ + "static/media/notification.569782bf.png";